import React from "react";

const CallLogs = () => {
  return <div></div>;
};

export default CallLogs;
